import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

const pendingReadTimers = new Map();
const readUpdateVersions = new Map();

const readVersionFor = id => readUpdateVersions.get(id) || 0;

const bumpReadVersion = id => {
  readUpdateVersions.set(id, readVersionFor(id) + 1);
};

const clearPendingReadTimer = id => {
  const timer = pendingReadTimers.get(id);
  if (timer) {
    clearTimeout(timer);
    pendingReadTimers.delete(id);
  }
};

export default {
  markMessagesRead: async ({ commit }, data) => {
    try {
      const version = readVersionFor(data.id);
      const {
        data: { id, agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessageRead(data);
      clearPendingReadTimer(id);
      if (unreadCount > 0) return;

      const timer = setTimeout(() => {
        if (version === readVersionFor(id)) {
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
        }
        pendingReadTimers.delete(id);
      }, 4000);
      pendingReadTimers.set(id, timer);
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      bumpReadVersion(id);
      clearPendingReadTimer(id);
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
